import { firestore } from "@crema/services/auth/firebase/firebase";
import { store } from "App";
import _ from "lodash";

export function isUserAdmin(){

    return store?.getState().auth?.user?.userProfile?.permissions?.includes('ADMIN');
}

export const getInQueryResultWithChunks = async (collectionName: string, fieldName: string, inList: string[]) => {
    let inSet = Array.from(new Set(inList));
    let result: any[] = [];
    await Promise.all(
      _.chunk(inSet, 10).map(inListChunk => {

        return firestore.collection(collectionName).where(fieldName, 'in', inListChunk).get()
          .then((qs) => {
            let resultChunk: any[] = qs.docs.map(doc => ({...doc.data(), id: doc.id}));
            result.push(...resultChunk);
          })
          // .catch(console.error);
      }));
    return result;
  }